import React from 'react';
import DirectNavigationModel from './DirectNavigationModel';
import MobileMenu from './MobileMenu/MobileMenu.react';
import WebMenu from './WebMenu/WebMenu.react';
import {PropTypes} from 'prop-types';
import './DirectNavigationMenu.less';
import LocaleContext from '../../../../Contexts/Locale/Context';
import AbacusContext from '../../../../Contexts/Abacus/Context';
import withLifecycleLogging from '../../hoc/WithLifecycleLogging.react';

class DirectNavigationMenu extends React.PureComponent {
    render() {
        return (
            <AbacusContext.Consumer>
                {(experiments) => {
                    return (
                        <div className={'DirectNavigation'}>
                            {this.props.mediaMatches.screenXsMax ? (
                                <LocaleContext.Consumer>
                                    {(getTranslation) => (
                                        <MobileMenu
                                            navigation={this.props.navigation}
                                            sphereId={this.props.sphereId}
                                            onSelectNavSpace={this.props.onSelectNavSpace}
                                            ctaText={getTranslation(
                                                'messages',
                                                'directNav.exploreMore'
                                            )}
                                            labelTitle={getTranslation(
                                                'messages',
                                                'directNav.currentlyViewing.withPunct'
                                            )}
                                            onOpen={this.props.onOpen}
                                            onClose={this.props.onClose}
                                            useMediaGateway={this.props.useMediaGateway}
                                        />
                                    )}
                                </LocaleContext.Consumer>
                            ) : (
                                <WebMenu
                                    navigation={this.props.navigation}
                                    sphereId={this.props.sphereId}
                                    onSelectNavSpace={this.props.onSelectNavSpace}
                                    onOpen={this.props.onOpen}
                                    onClose={this.props.onClose}
                                    hotspotsHidden={this.props.hotspotsHidden}
                                    useMediaGateway={this.props.useMediaGateway}
                                />
                            )}
                        </div>
                    );
                }}
            </AbacusContext.Consumer>
        );
    }
}

DirectNavigationMenu.propTypes = {
    navigation: DirectNavigationModel.navigationType.isRequired,
    sphereId: PropTypes.string.isRequired,
    mediaMatches: PropTypes.shape({
        screenXsMax: PropTypes.bool,
    }).isRequired,
    onSelectNavSpace: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    hotspotsHidden: PropTypes.bool,
    useMediaGateway: PropTypes.bool,
};

export default withLifecycleLogging(DirectNavigationMenu);
